import React from 'react';
const SvgNwd = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg width="1em" height="1em" viewBox="0 0 100 100" {...props}>
      <defs>
        <path
          d="M56.94 88.09c.756 0 1.378-.078 1.864-.235.869-.292 1.58-.854 2.134-1.685.442-.666.76-1.52.955-2.56a9.767 9.767 0 00.168-1.73c0-2.044-.406-3.63-1.218-4.761-.813-1.13-2.12-1.696-3.925-1.696h-3.965V88.09h3.987zm-6.233-14.588h6.682c2.269 0 4.028.805 5.279 2.415 1.115 1.452 1.673 3.313 1.673 5.582 0 1.751-.33 3.335-.988 4.75-1.16 2.5-3.156 3.751-5.986 3.751h-6.66V73.502z"
          id="nwd_svg__a"
        />
        <path id="nwd_svg__b" d="M14.288 73.502h2.639l8.333 13.365V73.502h2.123V90h-2.505l-8.456-13.353V90h-2.134z" />
        <path
          id="nwd_svg__c"
          d="M30.987 73.502l3.11 13.42 3.73-13.42h2.425l3.729 13.42 3.11-13.42h2.449L45.205 90h-2.347L39.05 76.321 35.22 90h-2.347L28.56 73.502z"
        />
        <path
          d="M.536.119c1.45 15.203 4.538 30.268 9.198 45.199-1.186-9.694-1.581-21.958-1.483-27.893.099-5.934 2.868-7.813 7.319-.89 3.704 5.76 14.912 28.41 14.744 28.585l9.512.198h.001L32.482 34.93 9.438.216.536.118z"
          id="nwd_svg__e"
        />
        <radialGradient
          cx="64.359%"
          cy="63.97%"
          fx="64.359%"
          fy="63.97%"
          r="118.659%"
          gradientTransform="matrix(-.96827 .05085 -.73055 -.57604 1.734 .975)"
          id="nwd_svg__d"
        >
          <stop stopColor="#1F508C" offset="0%" />
          <stop stopColor="#4679B8" offset="100%" />
        </radialGradient>
        <radialGradient
          cx="175.147%"
          cy="6.225%"
          fx="175.147%"
          fy="6.225%"
          r="249.48%"
          gradientTransform="matrix(.9266 .06878 -.86758 .391 .183 -.083)"
          id="nwd_svg__g"
        >
          <stop stopColor="#0B2B54" offset="0%" />
          <stop stopColor="#4679B8" offset="100%" />
        </radialGradient>
        <linearGradient x1="50.579%" y1="90.887%" x2="50%" y2="0%" id="nwd_svg__f">
          <stop stopColor="#20508D" offset="0%" />
          <stop stopColor="#4779B9" offset="59.285%" />
          <stop stopColor="#749BCB" offset="100%" />
        </linearGradient>
        <linearGradient x1="27.906%" y1="-16.262%" x2="72.094%" y2="135.003%" id="nwd_svg__h">
          <stop stopColor="#0C2C54" offset="0%" />
          <stop stopColor="#4779B9" offset="70.757%" />
          <stop stopColor="#749BCB" offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M4 2v20h24V8h-6V2z" fill="#FFF" />
        <path fill="#6B94C8" d="M11 3v94h78V23H69V3z" />
        <path fill="#FFF" d="M15 8h54v15h16v50H15z" />
        <path fill="#A1C4EE" d="M69 3l20 20H69z" />
        <path fill="#1B3F63" opacity={0.2} d="M69 23h20v20z" />
        <g fillRule="nonzero" transform="translate(11 3)">
          <use fill="#000" xlinkHref="#nwd_svg__a" />
          <use fill="#FFF" xlinkHref="#nwd_svg__a" />
        </g>
        <g fillRule="nonzero" transform="translate(11 3)">
          <use fill="#000" xlinkHref="#nwd_svg__b" />
          <use fill="#FFF" xlinkHref="#nwd_svg__b" />
        </g>
        <g fillRule="nonzero" transform="translate(11 3)">
          <use fill="#000" xlinkHref="#nwd_svg__c" />
          <use fill="#FFF" xlinkHref="#nwd_svg__c" />
        </g>
        <g>
          <path
            d="M29.814 64.588l-.098-44.647 8.629.096 1.344 1.916c7.679 10.946 14.93 21.284 17.404 21.818l.007.001.005.001c.021.002.041.004.062.004a.457.457 0 00.33-.15c.497-.51.747-2.559.809-6.643.055-3.602-.051-8.433-.164-13.076l1.316-3.345 9.092.067.098 44.148-9.255-.192c-.92-1.137-13.467-16.657-14.209-17.568a13.63 13.63 0 01-.181-.225c-.67-.838-1.793-2.241-2.77-2.241-1.027 0-1.533 1.43-1.547 4.374l-.059 13.788-1.967 2.067-8.846-.193z"
            fill="#4779B9"
          />
          <path
            d="M.635 45.12l9.095.198.004-.001C5.073 30.385 1.985 15.32.536.117l.1 45.003z"
            transform="translate(29 19.644)"
            fill="url(#nwd_svg__d)"
          />
          <path
            d="M.925.74c3.589 17.797 5.86 32.692 2.146 34.191l7.345 10.387-.1-44.508L.926.74z"
            transform="translate(58.412 19.644)"
            fill="url(#nwd_svg__f)"
          />
          <path
            d="M1.51 4.232c.259 10.52.423 19.904-.83 19.72 4.117 5.091 5.54 8.735 4.351 10.98C8.745 33.431 6.475 18.536 2.885.74L1.511 4.232z"
            transform="translate(56.451 19.644)"
            fill="url(#nwd_svg__g)"
          />
          <path d="M38.438 19.86l23.044 34.715c1.19-2.244-.234-5.888-4.352-10.978-2.555-.552-10.8-12.498-18.692-23.737z" />
          <path
            d="M.408 5.66C.31 11.596.705 23.86 1.89 33.554l2.072-2.178s.047-11.166.06-13.856c.03-7.382 3.167-3.038 4.179-1.796.776.95 14.262 17.632 14.262 17.632.356.191-11.004-22.779-14.738-28.585C5.737 1.675 4.082.34 2.853.34 1.334.34.463 2.38.408 5.66"
            transform="translate(36.843 31.408)"
            fill="url(#nwd_svg__h)"
          />
          <g fill="#A3BCDC">
            <path d="M38.439 19.86l.851 1.25.849 1.254 1.696 2.504 3.375 5.024.843 1.257.84 1.259 1.677 2.516 3.355 5.038 3.337 5.048 1.669 2.524 1.66 2.53 1.66 2.53.83 1.266.413.633c.14.21.287.416.429.623 1.146 1.66 2.296 3.318 3.437 4.98-1.177-1.637-2.346-3.282-3.518-4.924-.146-.206-.295-.41-.439-.616l-.422-.628-.844-1.256-1.688-2.511-1.687-2.512-1.677-2.519-3.357-5.035-3.34-5.048-1.668-2.524-.835-1.262-.83-1.265-3.32-5.06-1.65-2.537-.826-1.269-.82-1.27zM29.536 19.761l.123 1.034.117 1.034.254 2.066.264 2.064.285 2.062a264.3 264.3 0 001.298 8.22l.363 2.048.384 2.046.397 2.042.412 2.039.427 2.037.446 2.033.456 2.03.236 1.015.233 1.013-.268-1.005-.263-1.006-.508-2.021-.48-2.026-.459-2.032c-.149-.677-.294-1.356-.438-2.035l-.414-2.041-.39-2.046-.37-2.05-.345-2.054-.323-2.058-.3-2.06c-.095-.688-.186-1.377-.276-2.066l-.252-2.066-.231-2.07-.201-2.073-.09-1.036-.087-1.038z" />
            <path d="M61.483 54.575c.167-.075.323-.171.46-.292.134-.122.26-.256.36-.408.21-.297.36-.631.478-.975.118-.345.204-.7.27-1.057.066-.358.114-.72.15-1.082.145-1.451.121-2.915.049-4.373a75.811 75.811 0 00-.372-4.366c-.16-1.45-.35-2.9-.56-4.347a201.85 201.85 0 00-.671-4.333c-.234-1.444-.488-2.884-.736-4.324-.252-1.442-.513-2.88-.78-4.32l-.794-4.315.233 1.073.228 1.072.449 2.15c.289 1.434.571 2.869.845 4.305.546 2.876 1.04 5.761 1.462 8.66.206 1.447.395 2.9.549 4.356.15 1.456.277 2.917.329 4.381.027.733.038 1.466.025 2.2a22.844 22.844 0 01-.139 2.194c-.046.364-.104.727-.18 1.086a7.23 7.23 0 01-.298 1.061c-.127.345-.287.68-.508.976a2.25 2.25 0 01-.377.4 1.888 1.888 0 01-.472.278M54.379 54.432l-1.54-2.972c-.513-.991-1.03-1.98-1.55-2.967a430.8 430.8 0 00-3.14-5.91c-1.073-1.956-2.135-3.92-3.297-5.819-.584-.946-1.213-1.867-1.924-2.717a10.714 10.714 0 00-1.15-1.188 6.031 6.031 0 00-.652-.498 3.397 3.397 0 00-.718-.366 1.898 1.898 0 00-.772-.125 1.41 1.41 0 00-.722.252c-.109.072-.207.16-.297.257a2.33 2.33 0 00-.249.312 3.764 3.764 0 00-.373.72 7.562 7.562 0 00-.42 1.59 13.858 13.858 0 00-.159 1.651c-.058 2.225-.022 4.46.011 6.689.041 2.23.11 4.46.207 6.689a240.787 240.787 0 00.156 3.343c.059 1.115.125 2.227.194 3.341l-.136-1.668c-.042-.555-.085-1.112-.12-1.67a242.343 242.343 0 01-.21-3.341c-.122-2.229-.212-4.46-.275-6.69a158.856 158.856 0 01-.061-5.861c.003-.279.005-.558.017-.84.02-.561.068-1.122.156-1.678a7.81 7.81 0 01.427-1.641 4.03 4.03 0 01.395-.764c.08-.12.169-.236.27-.342a1.841 1.841 0 01.732-.495c.142-.051.291-.08.44-.09.15-.01.3-.003.445.023.145.025.289.061.425.113.274.097.528.237.766.394.24.156.463.332.677.519.426.373.809.788 1.17 1.218.72.865 1.35 1.795 1.934 2.748a87.3 87.3 0 011.678 2.902c.544.975 1.072 1.96 1.595 2.944a410.755 410.755 0 013.085 5.945 567.81 567.81 0 011.502 2.99l.746 1.5.737 1.502z" />
          </g>
        </g>
      </g>
    </svg>
  );
});
export default SvgNwd;
SvgNwd.iconName = 'nwd';
SvgNwd.displayName = 'SvgNwd';
